<template>
    <paper class="wrm-performance-adjustment">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :currentPage="page.pageNo"
            :initSearchInfo="initSearchInfo"
            searchId="supPerformanceAdjustmentSearchId"
            pageID="supPerformanceAdjustmentPageId250618"
            @btnClick="handleBtnClick"
            @attach-btn="handleAttach"
            @audit-btn="handleAudit"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="table-module-btn">
                <el-button class="bigData-btn-temp" type="primary" size="mini" :loading="tempLoading" @click="handleTemp">下载整改模版</el-button>
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button class="bigData-btn-export" icon="el-icon-download" size="mini" :loading="exportLoading" @click="handleExport"></el-button>
                </el-tooltip>
            </div>
        </m-pane>
        <AttachmentDialog ref="amRef" @success="getTableData" />
        <AuditInfoDialog ref="aiRef" @success="getTableData" :isPerformanceAdjustment="true"/>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </paper>
</template>
<script>
import dayjs from 'dayjs';
import bigDataLog from '@/utils/bigDataLog';
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import AttachmentDialog from './AttachmentDialog.vue';
import AuditInfoDialog from './AuditInfoDialog.vue';
import Preview from '../../../components/viewAttachment.vue';
import config from './supConfig';
import { getPerformanceList, exportPerformance } from '../../../api/warehouseResourceManagement/performanceAssessDetail.js';
import { downloadRegisterGuide } from '../../../api/warehouseResourceManagement/performanceAdjustment.js';
import { AUDIT_STATUS, OPERATE_QUALITY } from '../../../constant/constant.js';
export default {
    name: 'performanceAdjustment',
    components: { paper, mPane, AttachmentDialog, AuditInfoDialog, Preview },
    data() {
        return {
            loading: false,
            tempLoading: false,
            exportLoading: false,
            totalData: [],
            initSearchInfo: {}, //初始化查询参数
            searchObj: {},
            config,
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            // dict: []
            attachmentShow: false,
            rowData: {},
            attachmentList: []
        };
    },
    methods: {
        getTableData() {
            this.loading = true;
            getPerformanceList(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list.map(item => {
                        const { WITHDRAW, REJECT, DRAFT, PENDING } = AUDIT_STATUS;
                        const { NORMAL, HIGH_RISK } = OPERATE_QUALITY
                        item.hiddenEvent = [];
                        if (!item.supplierLspMipAuditId) {
                            item.hiddenEvent.push('audit');
                        }
                        if ([WITHDRAW, REJECT, DRAFT, PENDING].includes(item.auditStatus) || [NORMAL, HIGH_RISK].includes(item.recalculateOperationalQuality)) {
                            item.hiddenEvent.push('attach');
                        }
                        return item;
                    });
                }
            }).finally(() => { this.loading = false; });
        },
        getParams() {
            const params = JSON.parse(JSON.stringify(this.searchObj));
            params.type = '3'; // 3-供应商平台端-绩效整改
            params.pageNo = this.page.pageNo;
            params.pageSize = this.page.pageSize;
            if (params.assessmentMonthList && params.assessmentMonthList.length) {
                params.assessmentStartMonth = dayjs(params.assessmentMonthList[0]).format('YYYY-MM');
                params.assessmentEndMonth = dayjs(params.assessmentMonthList[1]).format('YYYY-MM');
            }
            delete params.assessmentMonthList;
            return params;
        },
        searchChange(data) { // 点击查询
            this.page.pageNo = 1;
            this.searchObj = data;
            this.getTableData();
            try { bigDataLog.sendDetailMessageByNames('工作台,仓储资源管理,绩效整改,查询'); } catch (e) { }
        },
        pageChange(pageNo) { // 切换分页页数
            this.page.pageNo = pageNo;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleBtnClick(val, index, row, prop, buttonName) {
            if (!val) {
                return this.$message.warning('暂无附件!')
            }
            if (buttonName === '查看') {
                this.rowData = {
                    downUrl: val,
                    fileName: row.attachmentFileName
                    // fileId: data.fileId
                };
                this.attachmentShow = true;
            } else if (buttonName === '下载') {
                const a = document.createElement('a');
                a.href = val;
                a.download = row.attachmentFileName;
                a.click();
            }
        },
        handleTemp() {
            this.tempLoading = true;
            downloadRegisterGuide({ fileName: 'remediationInterviewReportTemplate.xlsx' }).then(res => {
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const blob = new Blob([res], {
                    type: fileType
                });
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = '整改模版.xlsx';
                a.click();
            }).finally(() => { this.tempLoading = false; });
            try { bigDataLog.sendDetailMessageByNames('工作台,仓储资源管理,绩效整改,下载整改模版'); } catch (e) { }
        },
        handleExport() {
            const params = this.getParams();
            delete params.pageNo;
            delete params.pageSize;
            this.exportLoading = true;
            exportPerformance(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data || '正在导出，请留意右上角文件中心下载文件！');
                }
            }).finally(() => { this.exportLoading = false; });
            try { bigDataLog.sendDetailMessageByNames('工作台,仓储资源管理,绩效整改,导出'); } catch (e) { }
        },
        handleAttach(row) {
            this.$refs.amRef.open(row);
            try { bigDataLog.sendDetailMessageByNames('工作台,仓储资源管理,绩效整改,上传整改附件'); } catch (e) { }
        },
        handleAudit(row) {
            this.$router.push({
                path: '/lsrm/mipIframe',
                query: {
                    processId: row.supplierLspMipAuditMipId,
                    supplierLspMipAuditId: row.supplierLspMipAuditId,
                    id: row.id,
                }
            })
            // this.$refs.aiRef.open(row);
            try { bigDataLog.sendDetailMessageByNames('工作台,仓储资源管理,绩效整改,流程信息'); } catch (e) { }
        }
    },
    mounted() {
        const { recalculateOperationalQualityList } = this.$route.query
        if (recalculateOperationalQualityList) {
            this.initSearchInfo = { recalculateOperationalQualityList: recalculateOperationalQualityList.split(',') }
            this.searchObj = { recalculateOperationalQualityList: recalculateOperationalQualityList.split(',') }
        }
        this.getTableData();
    },
    activated(){
        this.getTableData();
    },
};
</script>
<style lang="less">
.wrm-performance-adjustment {
    #mPane3 .el-table {
        min-height: calc(100vh - 170px);
        max-height: calc(100vh - 170px);
    }
}
</style>
